import useInsightsAnalytics, { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import {
  getInboundReferralAnalyticsFilters,
  useInboundReferralsInsightsStore,
} from 'stores/inboundReferralsInsightsStore';

type Options = {
  queryKey?: string;
  enabled?: boolean;
  extraFilters?: Record<string, unknown> | null;
};

export default function useInboundReferralAnalytics(
  queryParams: InsightsQueryParams,
  { queryKey = 'inboundReferralAnalytics', enabled = true, extraFilters = null }: Options = {}
) {
  const filters = useInboundReferralsInsightsStore((state) => getInboundReferralAnalyticsFilters(state));

  return useInsightsAnalytics(queryParams, filters, { queryKey, enabled, extraFilters });
}
